import type { FC, ReactNode } from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { AnimatePresence, motion } from 'motion/react';
import { useState } from 'react';
import styles from './Tooltip.module.css';

type Props = {
    title: ReactNode;
    children: ReactNode;
};

export const Tooltip: FC<Props> = ({ title, children }) => {
    const [open, setOpen] = useState(false);
    // TODO мобильная адаптация путем добавления стейта и всяких приколов с онКликами маус энетарми и прочим
    return (
        // eslint-disable-next-line react/no-context-provider
        <RadixTooltip.Provider delayDuration={200}>
            <RadixTooltip.Root open={open} onOpenChange={setOpen}>
                <RadixTooltip.Trigger asChild>
                    <div tabIndex={0} className={styles.trigger}>
                        {children}
                    </div>
                </RadixTooltip.Trigger>
                <AnimatePresence>
                    {open && (
                        <RadixTooltip.Portal forceMount>
                            <RadixTooltip.Content asChild sideOffset={4} className={styles.content}>
                                <motion.div
                                    initial={{ opacity: 0, scale: 0.6 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0.9 }}
                                >
                                    {title}
                                    <RadixTooltip.Arrow className={styles.arrow} />
                                </motion.div>
                            </RadixTooltip.Content>
                        </RadixTooltip.Portal>
                    )}
                </AnimatePresence>
            </RadixTooltip.Root>
        </RadixTooltip.Provider>
    );
};
